<template>
	<div class="container">
		<div class="cover">
			<img :src="img_url" alt="" />
			<a class="play-icon" :src="panorama_url"></a>
		</div>
		<div class="content">
			<div class="basicInfo">
				<div class="title">
					<span>{{ name }}</span>
				</div>
				<div class="info">
					<span>业态：{{ industry_name }}</span>
					<span>朝向：{{ room_facing }}</span>
				</div>
				<div class="info">
					<span>面积 : {{ display_area }}平方米</span>
					<span>租金 : {{ min_rent }}-{{ max_rent }}元/平方米</span>
				</div>
			</div>
		</div>
		<div class="buildingInfo">
			<div class="title">
				<span>楼盘信息</span>
			</div>
			<div class="col">
				<div class="infoItem">
					<span class="ask">竣工年份</span>
					<span class="answer">{{ complete_time }}</span>
				</div>
				<div class="infoItem">
					<span class="ask">物业公司</span>
					<span class="answer">{{ property_company }}</span>
				</div>
			</div>
			<div class="col">
				<div class="infoItem">
					<span class="ask">标准层高</span>
					<span class="answer">{{ standard_height }}</span>
				</div>
				<div class="infoItem">
					<span class="ask">空调类型</span>
					<span class="answer">{{ ac_type }}</span>
				</div>
			</div>
			<div class="col">
				<div class="infoItem">
					<span class="ask">等级</span>
					<span class="answer">{{ level }}</span>
				</div>
				<div class="infoItem">
					<span class="ask">电梯</span>
					<span class="answer">{{ lift_count }}</span>
				</div>
			</div>
		</div>
		<div class="introduction">
			<div class="title">
				<span>简介</span>
			</div>
			<div class="content">
				<div v-html="content"></div>
			</div>
		</div>
		<div class="reserve">
			<button style="border-right: 1px solid #fff;" @click="reserve">预约看房</button>
			<button @click="callPhone">立即联系</button>
		</div>
	</div>
</template>

<script>
import moment from 'moment'
export default {
	data() {
		return {
			img_url: '',
			panorama_url: '',
			industry_name: '',
			name: '',
			room_facing: '',
			display_area: '',
			min_rent: '',
			max_rent: '',
			complete_time: '',
			property_company: '',
			standard_height: '',
			ac_type: '',
			level: '',
			lift_count: '',
			content: '',
			phone: '',
			min_property_rent: '',
			max_property_rent: '',
		}
	},
	methods: {
		callPhone() {
			let phone = this.phone
			phone === '' && alert('招商园区尚未配置电话')
			window.location.href = 'tel://' + phone
		},
		reserve() {
			this.$router.push({
				path: '/reserve',
				query: {
					id: this.id,
					title: this.name,
					room_facing: this.room_facing,
					display_area: this.display_area,
					min_rent: this.min_rent,
					max_rent: this.max_rent,
					min_property_rent: this.min_property_rent,
					max_property_rent: this.max_property_rent,
				},
			})
		},
		getData() {
			const { businessDetailId, parkId } = this.$route.query
			let businessDetail = `${this.vaxios.host}/open/api/v1/investments/room/${businessDetailId}/detail`
			let phoneUrl = `${this.vaxios.host}/open/api/v1/introductions/community/${parkId}/investment-phone`
			this.vaxios.get(
				businessDetail,
				{},
				(res) => {
					const data = res.data
					this.img_url = data.attach_list[0].url
					this.panorama_url = data.panorama_url
					this.name = data.name
					this.industry_name = data.industry_name
					this.room_facing = data.room_facing
					this.display_area = Number(data.display_area).toFixed(2)
					this.min_rent = data.min_rent
					this.max_rent = data.max_rent
					this.complete_time = moment(Number(data.complete_time)).format('YYYY')
					this.property_company = data.property_company
					this.standard_height = data.standard_height
					this.ac_type = data.ac_type
					this.level = data.level
					this.lift_count = data.lift_count
					this.content = data.content
					this.min_property_rent = data.min_property_rent
					this.max_property_rent = data.max_property_rent
					this.id = data.id

					this.vaxios.get(phoneUrl, {}, (res) => {
						this.phone = res.data.investmentPhone
					})
				},
				function(err) {
					console.log(err)
				}
			)
		},
	},
	mounted() {
		this.getData()
	},
}
</script>

<style scoped lang="scss">
.container {
	background: #f7f4f8;
	height: 100%;
}
.cover {
	width: 100%;
	height: 185px;
	position: relative;
	img {
		width: 100%;
		height: 100%;
	}
	.play-icon {
		position: absolute;
		right: 5%;
		bottom: 20%;
		width: 48px;
		height: 48px;
		background-image: url('../../assets/play.png');
	}
}
.content {
	height: 160px;
	position: relative;
	background: #fff;
	margin-bottom: 10px;
	.basicInfo {
		background: #fff;
		position: absolute;
		top: -30px;
		left: 0;
		right: 0;
		margin: 8px;
		padding: 14px;
		height: 140px;
		border-radius: 10px;
		box-shadow: 1px 1px 5px -1px #808080;
		.title {
			font-size: 21px;
			margin-top: 12px;
			margin-bottom: 24px;
			font-weight: 600;
		}
		.info {
			display: flex;
			color: rgba(0, 0, 0, 0.45);
			font-size: 12px;
			margin-bottom: 5px;
			span {
				flex: 1;
			}
		}
	}
}
.buildingInfo {
	background: #fff;
	margin-bottom: 10px;
	.title {
		height: 52px;
		line-height: 52px;
		font-size: 16px;
		font-weight: 600;
		padding-left: 16px;
		border-bottom: 1px solid rgba(228, 228, 228, 1);
		margin-bottom: 20px;
	}
	.col {
		display: flex;
		padding: 0 16px;
		.infoItem {
			flex: 1;
			width: 50%;
			margin-bottom: 24px;
			.ask {
				display: block;
				color: rgba(0, 0, 0, 0.45);
				font-size: 14px;
				margin-bottom: 8px;
			}
			.answer {
				display: block;
				font-size: 15px;
			}
		}
	}
}
.introduction {
	background: #fff;
	margin-bottom: 35px;
	.title {
		height: 52px;
		line-height: 52px;
		font-size: 16px;
		font-weight: 600;
		padding-left: 16px;
		border-bottom: 1px solid rgba(228, 228, 228, 1);
	}
	.content {
		height: 100%;
		padding: 25px 16px;
		font-size: 15px;
		line-height: 28px;
	}
}
.reserve {
	width: 100%;
	height: 45px;
	line-height: 35px;
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	button {
		width: 50%;
		height: 100%;
		background: #31acff;
		color: #fff;
		border: 0;
		font-size: 16px;
	}
}
</style>
